<template>
  <v-row
    justify="center"
    :class="{ invisible: !isactiondialogactive }"
  >
    <v-dialog
      v-model="isactiondialogactive"
      persistent
      max-width="512"
    >
      <v-card>
        <v-card-title class="headline">
          <slot name="header" />
        </v-card-title>
        <v-card-text>
          <slot name="content" />
        </v-card-text>
        <slot name="buttons" />
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    isactiondialogactive: {
      required: true,
      type: Boolean
    }
  }
};
</script>

<style>
.invisible {
  display: none;
}
</style>
